import { withCmsContent } from '@zep/next/server';
import { CmsEntries } from '../../consts';
import { LegacyLandingPageView } from '../../views';
const LegacyLandingPage = () => {
  return <LegacyLandingPageView data-sentry-element="LegacyLandingPageView" data-sentry-component="LegacyLandingPage" data-sentry-source-file="landing.tsx" />;
};
export default LegacyLandingPage;
export const getStaticProps = withCmsContent(CmsEntries.LANDING_PAGE);